import React from 'react'
import styled, { css } from 'styled-components'
import { Flex, Link } from '@raysync/common/components'
import intl from 'react-intl-universal'
import { Media, textEllipsis } from '@raysync/common/theme'

const BreadCrumbContainer = styled(Flex)`
  ${({ theme: { color } }) => css`
    justify-content: flex-start;
    align-items: center;
    a {
      text-decoration: none;
      color: #1f2329;
      font-size: 14px;
      font-weight: 700;
      flex-shrink: 0;
    }
    ${Media.phone`
      font-size: .4rem;
      flex-wrap: wrap;
    `}
  `}
`
export const Delimiter = styled.span`
  font-size: 14px;
  margin: 0 8px;
  font-weight: 700;
  color: #1f2329;
`

class BreadCrumb extends React.PureComponent {
  render() {
    const { items = [] } = this.props

    return (
      <BreadCrumbContainer>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <Link to={item.url} style={{ cursor: item.url ? 'pointer' : 'default' }}>
              {item.title}
            </Link>
            {index !== items.length - 1 && <Delimiter>&gt;</Delimiter>}
          </React.Fragment>
        ))}
      </BreadCrumbContainer>
    )
  }
}

export default BreadCrumb
